import axios, { AxiosResponse } from "axios";
import { baseUrl } from "../utils/constants";
import { getItem, removeItem } from "../utils/utils";
import { ROLES } from "./endpoints";
import { SIGNOUTPATH } from "../routes/routePaths";
import qs from "qs";

const client = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Attach token to every request
client.interceptors.request.use(
  (config) => {
    const token = getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async (error: any) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401) {
      // Skip navigation for /auth/verifyotp endpoint
      if (!originalRequest.url?.includes("/auth/verifyotp")) {
        removeItem("token");
        window.location.href = "/login";
        return error?.response?.data?.message;
      }
    }
    if (
      error?.response?.status === 403 &&
      originalRequest.url?.includes(`${baseUrl}${ROLES}`)
    ) {
      removeItem("showRoleAlertInfo");
      window.location.href = SIGNOUTPATH;
    }
    return Promise.reject(error?.response?.data);
  }
);

export { client };
